import React, {useState} from "react";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import DashboardChoice from '../components/DashboardChoice';


export default function DashboardChoicePanel({facilityId, 
	floorId, spaceId, spaceTypeId, classificationId, classificationItemId,
	display, setDisplay}){
	
	
	const thisContent = {
		display:display,
		flexDirection:"column",
		position:"fixed",
		top:"25vh",
		left:"calc(50% - 376px)",
		width:"812px",
		height:"300px",
		background: 'linear-gradient(180deg, #2a2c31 0%, #18191d 40%, #0e0f12 100%)',
		border: '1px solid rgba(255,255,255,0.05)',
		borderRadius: '20px',
		boxShadow: '0 8px 24px rgba(0,0,0,0.42),inset 0 1px 2px rgba(255,255,255,0.08),inset 0 -2px 4px rgba(0,0,0,0.45)',
		backdropFilter: 'blur(8px)'
	};
	
	const closeIconContainer = {
		display:"flex",
		width:"100%",
		flexDirection:"row-reverse"
	};
	
	const closeIcon = {
		display:"flex",
		margin:"10px",
		width:"20px",
		height:"20px",
		color:"lightgrey",
		cursor:"pointer"
	};
	
	const closeThis = () => {
		setDisplay("none");
	};
	
	const navigatorContainer = {
		display:"flex",
		width:"calc(100% - 20px)",
		padding:"10px",
		flexWrap:"wrap"
	};
	
	const dashboardChoices = [
		{label:"Utilisation", icon:"users", facilityId:facilityId, isLive:true, url:"utilisationall"},
		{label:"Space Use", icon:"city", facilityId:facilityId, isLive:true, url:"spaceall"},
		{label:"Energy", icon:"lightbulb", facilityId:facilityId, isLive:false, url:""},
		{label:"Compliance", icon:"check", facilityId:facilityId, isLive:false, url:""},
		{label:"Operations", icon:"cogs", facilityId:facilityId, isLive:false, url:""},
		{label:"Assets & Condition", icon:"laptop", facilityId:facilityId, isLive:false, url:""}
	];
	
	const dashboardChoiceMap = dashboardChoices.map((item, index) =>
		<DashboardChoice
			icon={item.icon}
			label={item.label}
			facilityId={item.facilityId}
			isLive={item.isLive}
			url={item.url}
		/>
	);
	
	return (
		<div style={thisContent}>
			<div style={closeIconContainer}>
				<FontAwesomeIcon icon="times" style={closeIcon} onClick={closeThis}/>
			</div>
			<div style={navigatorContainer}>
				{dashboardChoiceMap}
			</div>
		</div>
	);
}